import { SelectChangeEvent } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/produto/produto.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import EditProdutos from './EditProdutos.template';
import CloneProduto from './CloneProduto';
import { formatDinheiro } from 'utils/formatDinheiro';
import assets from '../../assets';

const api = useApi();

export default function Produtos() {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setClearLoading }: any = useContext(LoadingContext);
  const [produto, setProduto] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [prod, setProd] = useState();
  const [openImageModal, setOpenImageModal] = useState(false);
  const [largeImageURL, setLargeImageURL] = useState('');
  const [caracteristicaIndex] = useState(0);
  const [indexPicture] = useState(0);
  const [edit, setEdit] = useState<boolean>(false);
  const [clone, setClone] = useState<boolean>(false);
  const [allProduto, setAllProduto] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Imagem', 'Editar', 'Excluir', 'Duplicar'].includes(column)),
  );

  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  const handleExcluir = (row: string) => {
    setPath('/produto/');
    setItemExclude(row);
    setOpen(true);
  };

  const getAllProdutos = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/produto?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/produto?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllProduto(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(
        `/produto?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(
          ',',
        )}`,
      )
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
        }
        setClearLoading();
        setProduto(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllProdutos();
  }, [page, like, selectedFilterColumns]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleImageClick = (url) => {
    setLargeImageURL(url);
    setOpenImageModal(true);
  };

  const handleAtualizar = (row: any) => {
    setProd(row);
    setEdit(true);
    setClone(false);
  };

  const handleClone = (row: any) => {
    setProd(row);
    setEdit(false);
    setClone(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          {
            campo: (
              <div
                onClick={() =>
                  handleImageClick(
                    row?.caracteristicas[caracteristicaIndex]?.fotos[indexPicture]?.imagem || assets.images.produto,
                  )
                }
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={row?.caracteristicas[caracteristicaIndex]?.fotos[indexPicture]?.imagem || assets.images.produto}
                  alt={row?.nome || 'Imagem do Produto'}
                  width={100}
                />
              </div>
            ),
            onClick: null,
            link: false,
          },
          { campo: row?.SKU || '-', onClick: null, link: false },
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.categoria?.nome || '-', onClick: null, link: false },
          { campo: formatDinheiro(row?.precoBase, 4), onClick: null, link: false },
          { campo: formatDinheiro(row?.precoConsumo, 4), onClick: null, link: false },
          { campo: formatDinheiro(row?.precoRevenda, 4), onClick: null, link: false },
          { campo: row?.ipi, onClick: null, link: false },
          { campo: row?.imposto, onClick: null, link: false },
          { campo: row?.frete, onClick: null, link: false },
          { campo: row?.margin, onClick: null, link: false },
          { campo: row?.altura, onClick: null, link: false },
          { campo: row?.largura, onClick: null, link: false },
          { campo: row?.profundidade, onClick: null, link: false },
          { campo: row?.NCM, onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleAtualizar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
          { campo: 'Duplicar', onClick: () => handleClone(row), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: [...table.header],
    type: table.type,
    rows: formataTable(produto),
  };

  const arrListAll = {
    header: [...table.header],
    type: table.type,
    rows: formataTable(allProduto),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      const filteredColumns = JSON.parse(savedColumns).filter((column) => table.header.includes(column));
      setSelectedFilterColumns(filteredColumns);
    }
  }, []);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const updatedFilterColumns = filteredColumns.filter(
      (column) => table.header.includes(column) && !['Editar', 'Excluir'].includes(column),
    );
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <>
      <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)}>
        <img src={largeImageURL} alt="Imagem em Tamanho Maior" />
      </Dialog>
      {!edit && !clone && (
        <div>
          <ComponenteTables
            table={arrList}
            cadastro={cadastro}
            pageTotal={pageTotal}
            page={page}
            handleChangePage={handleChangePage}
            handleLike={handleLike}
            path={path}
            itemExclude={itemExclude}
            open={open}
            setOpen={setOpen}
            allData={arrListAll}
            selectedFilterColumns={selectedFilterColumns}
            handleFilterColumnsChange={handleFilterColumnsChange}
          />
        </div>
      )}
      {edit && !clone && <EditProdutos dado={prod} setEdit={() => setEdit(false)} />}
      {clone && !edit && <CloneProduto dado={prod} setEdit={() => setClone(false)} />}
    </>
  );
}
